// src/utils/ProProfileInfo.ts
// Centralized lists for professional profile fields

export const specialtyOptions = [
    'Internal Medicine', 'Cardiology', 'Neurology', 'Psychiatry', 'Dermatology', 'Ophthalmology',
    'ENT (Otolaryngology)', 'Orthopedics', 'Urology', 'Oncology', 'Endocrinology', 'Gastroenterology',
    'Pulmonology', 'Nephrology', 'Rheumatology', 'Hematology', 'Infectious Diseases', 'Allergy & Immunology',
    'Emergency Medicine', 'Family Medicine', 'Pediatrics', 'Obstetrics & Gynecology', 'Anesthesiology',
    'Radiology', 'Pathology', 'Nuclear Medicine', 'Physical Medicine & Rehabilitation', 'Plastic Surgery',
    'General Surgery', 'Cardiac Surgery', 'Neurosurgery', 'Orthopedic Surgery', 'Vascular Surgery',
    'Thoracic Surgery', 'Pediatric Surgery', 'Oral & Maxillofacial Surgery', 'Dentistry', 'Orthodontics',
    'Periodontics', 'Endodontics', 'Oral Surgery', 'Prosthodontics', 'Pediatric Dentistry', 'Nursing',
    'Pharmacy', 'Physiotherapy', 'Occupational Therapy', 'Speech Therapy', 'Clinical Psychology',
    'Medical Laboratory', 'Medical Imaging', 'Nutrition & Dietetics', 'Public Health', 'Health Administration',
    'Medical Research', 'Biomedical Engineering', 'Health Informatics'
];

export const subSpecialtyOptions = [
    'Interventional Cardiology', 'Electrophysiology', 'Heart Failure', 'Preventive Cardiology',
    'Pediatric Cardiology', 'Cardiac Imaging', 'Nuclear Cardiology', 'Critical Care Medicine',
    'Geriatric Medicine', 'Hospital Medicine', 'Palliative Care', 'Sleep Medicine', 'Sports Medicine',
    'Minimally Invasive Surgery', 'Robotic Surgery', 'Trauma Surgery', 'Transplant Surgery',
    'Bariatric Surgery', 'Colorectal Surgery', 'Hepatobiliary Surgery', 'Stroke Neurology', 'Epilepsy',
    'Movement Disorders', 'Neuromuscular Medicine', 'Headache Medicine', 'Neuro-oncology',
    'Pediatric Neurology', 'Child & Adolescent Psychiatry', 'Addiction Psychiatry', 'Forensic Psychiatry',
    'Geriatric Psychiatry', 'Consultation-Liaison Psychiatry', 'Interventional Radiology', 'Neuroradiology',
    'Musculoskeletal Radiology', 'Chest Radiology', 'Abdominal Radiology', 'Breast Imaging',
    'Pediatric Radiology', 'Spine Surgery', 'Joint Replacement', 'Hand Surgery', 'Foot & Ankle Surgery',
    'Pediatric Orthopedics', 'Trauma Orthopedics', 'Neonatology', 'Pediatric Intensive Care',
    'Pediatric Emergency Medicine', 'Developmental Pediatrics', 'Pediatric Endocrinology',
    'Pediatric Gastroenterology', 'Pediatric Hematology-Oncology', 'Maternal-Fetal Medicine',
    'Reproductive Endocrinology', 'Gynecologic Oncology', 'Urogynecology',
    'Minimally Invasive Gynecologic Surgery', 'Oral Pathology', 'Oral Radiology', 'Dental Public Health',
    'Oral Medicine', 'Orofacial Pain', 'Dental Anesthesiology', 'Toxicology', 'Emergency Medical Services',
    'Disaster Medicine', 'Wilderness Medicine', 'Pain Management', 'Cardiac Anesthesia',
    'Pediatric Anesthesia', 'Obstetric Anesthesia', 'Regional Anesthesia', 'Critical Care Anesthesia',
    'Forensic Pathology', 'Neuropathology', 'Dermatopathology', 'Hematopathology', 'Cytopathology',
    'Molecular Pathology', 'Telemedicine', 'Medical Informatics', 'Quality Improvement',
    'Medical Education', 'Research', 'Administration', 'Consulting', 'Medical Writing',
    'Regulatory Affairs', 'Clinical Trials', 'Pharmacovigilance', 'Medical Device', 'Biotechnology',
    'Digital Health', 'Artificial Intelligence in Medicine', 'Precision Medicine', 'Genomic Medicine',
    'Regenerative Medicine', 'Integrative Medicine', 'Functional Medicine'
];

export const countryOptions = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
    'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
    'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
    'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
    'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador',
    'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France',
    'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau',
    'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait',
    'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
    'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico',
    'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru',
    'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman',
    'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
    'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe',
    'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia',
    'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
    'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey',
    'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu',
    'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

export const countryOptionsFr = [
    'Afghanistan', 'Albanie', 'Algérie', 'Andorre', 'Angola', 'Antigua-et-Barbuda', 'Argentine', 'Arménie', 'Australie', 'Autriche',
    'Azerbaïdjan', 'Bahamas', 'Bahreïn', 'Bangladesh', 'Barbade', 'Biélorussie', 'Belgique', 'Belize', 'Bénin', 'Bhoutan',
    'Bolivie', 'Bosnie-Herzégovine', 'Botswana', 'Brésil', 'Brunei', 'Bulgarie', 'Burkina Faso', 'Burundi', 'Cap-Vert', 'Cambodge',
    'Cameroun', 'Canada', 'République centrafricaine', 'Tchad', 'Chili', 'Chine', 'Colombie', 'Comores', 'Congo', 'Costa Rica',
    'Croatie', 'Cuba', 'Chypre', 'République tchèque', 'République démocratique du Congo', 'Danemark', 'Djibouti', 'Dominique', 'République dominicaine', 'Équateur',
    'Égypte', 'El Salvador', 'Guinée équatoriale', 'Érythrée', 'Estonie', 'Eswatini', 'Éthiopie', 'Fidji', 'Finlande', 'France',
    'Gabon', 'Gambie', 'Géorgie', 'Allemagne', 'Ghana', 'Grèce', 'Grenade', 'Guatemala', 'Guinée', 'Guinée-Bissau',
    'Guyana', 'Haïti', 'Honduras', 'Hongrie', 'Islande', 'Inde', 'Indonésie', 'Iran', 'Irak', 'Irlande', 'Italie', 'Côte d\'Ivoire', 'Jamaïque', 'Japon', 'Jordanie', 'Kazakhstan', 'Kenya', 'Kiribati', 'Koweït',
    'Kirghizistan', 'Laos', 'Lettonie', 'Liban', 'Lesotho', 'Libéria', 'Libye', 'Liechtenstein', 'Lituanie', 'Luxembourg',
    'Madagascar', 'Malawi', 'Malaisie', 'Maldives', 'Mali', 'Malte', 'Îles Marshall', 'Mauritanie', 'Maurice', 'Mexique',
    'Micronésie', 'Moldavie', 'Monaco', 'Mongolie', 'Monténégro', 'Maroc', 'Mozambique', 'Myanmar', 'Namibie', 'Nauru',
    'Népal', 'Pays-Bas', 'Nouvelle-Zélande', 'Nicaragua', 'Niger', 'Nigeria', 'Corée du Nord', 'Macédoine du Nord', 'Norvège', 'Oman',
    'Pakistan', 'Palaos', 'Palestine', 'Panama', 'Papouasie-Nouvelle-Guinée', 'Paraguay', 'Pérou', 'Philippines', 'Pologne', 'Portugal',
    'Qatar', 'Roumanie', 'Russie', 'Rwanda', 'Saint-Kitts-et-Nevis', 'Sainte-Lucie', 'Saint-Vincent-et-les-Grenadines', 'Samoa', 'Saint-Marin', 'São Tomé-et-Principe',
    'Arabie saoudite', 'Sénégal', 'Serbie', 'Seychelles', 'Sierra Leone', 'Singapour', 'Slovaquie', 'Slovénie', 'Îles Salomon', 'Somalie',
    'Afrique du Sud', 'Corée du Sud', 'Soudan du Sud', 'Espagne', 'Sri Lanka', 'Soudan', 'Suriname', 'Suède', 'Suisse', 'Syrie',
    'Taïwan', 'Tadjikistan', 'Tanzanie', 'Thaïlande', 'Timor oriental', 'Togo', 'Tonga', 'Trinité-et-Tobago', 'Tunisie', 'Turquie',
    'Turkménistan', 'Tuvalu', 'Ouganda', 'Ukraine', 'Émirats arabes unis', 'Royaume-Uni', 'États-Unis', 'Uruguay', 'Ouzbékistan', 'Vanuatu',
    'Vatican', 'Venezuela', 'Vietnam', 'Yémen', 'Zambie', 'Zimbabwe'
];

// Create a mapping between English and French country names
export const countryNameMapping: { [key: string]: string } = {
    'Afghanistan': 'Afghanistan',
    'Albania': 'Albanie',
    'Algeria': 'Algérie',
    'Andorra': 'Andorre',
    'Angola': 'Angola',
    'Antigua and Barbuda': 'Antigua-et-Barbuda',
    'Argentina': 'Argentine',
    'Armenia': 'Arménie',
    'Australia': 'Australie',
    'Austria': 'Autriche',
    'Azerbaijan': 'Azerbaïdjan',
    'Bahamas': 'Bahamas',
    'Bahrain': 'Bahreïn',
    'Bangladesh': 'Bangladesh',
    'Barbados': 'Barbade',
    'Belarus': 'Biélorussie',
    'Belgium': 'Belgique',
    'Belize': 'Belize',
    'Benin': 'Bénin',
    'Bhutan': 'Bhoutan',
    'Bolivia': 'Bolivie',
    'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
    'Botswana': 'Botswana',
    'Brazil': 'Brésil',
    'Brunei': 'Brunei',
    'Bulgaria': 'Bulgarie',
    'Burkina Faso': 'Burkina Faso',
    'Burundi': 'Burundi',
    'Cabo Verde': 'Cap-Vert',
    'Cambodia': 'Cambodge',
    'Cameroon': 'Cameroun',
    'Canada': 'Canada',
    'Central African Republic': 'République centrafricaine',
    'Chad': 'Tchad',
    'Chile': 'Chili',
    'China': 'Chine',
    'Colombia': 'Colombie',
    'Comoros': 'Comores',
    'Congo': 'Congo',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatie',
    'Cuba': 'Cuba',
    'Cyprus': 'Chypre',
    'Czech Republic': 'République tchèque',
    'Democratic Republic of the Congo': 'République démocratique du Congo',
    'Denmark': 'Danemark',
    'Djibouti': 'Djibouti',
    'Dominica': 'Dominique',
    'Dominican Republic': 'République dominicaine',
    'Ecuador': 'Équateur',
    'Egypt': 'Égypte',
    'El Salvador': 'El Salvador',
    'Equatorial Guinea': 'Guinée équatoriale',
    'Eritrea': 'Érythrée',
    'Estonia': 'Estonie',
    'Eswatini': 'Eswatini',
    'Ethiopia': 'Éthiopie',
    'Fiji': 'Fidji',
    'Finland': 'Finlande',
    'France': 'France',
    'Gabon': 'Gabon',
    'Gambia': 'Gambie',
    'Georgia': 'Géorgie',
    'Germany': 'Allemagne',
    'Ghana': 'Ghana',
    'Greece': 'Grèce',
    'Grenada': 'Grenade',
    'Guatemala': 'Guatemala',
    'Guinea': 'Guinée',
    'Guinea-Bissau': 'Guinée-Bissau',
    'Guyana': 'Guyana',
    'Haiti': 'Haïti',
    'Honduras': 'Honduras',
    'Hungary': 'Hongrie',
    'Iceland': 'Islande',
    'India': 'Inde',
    'Indonesia': 'Indonésie',
    'Iran': 'Iran',
    'Iraq': 'Irak',
    'Ireland': 'Irlande',
    'Italy': 'Italie',
    'Ivory Coast': 'Côte d\'Ivoire',
    'Jamaica': 'Jamaïque',
    'Japan': 'Japon',
    'Jordan': 'Jordanie',
    'Kazakhstan': 'Kazakhstan',
    'Kenya': 'Kenya',
    'Kiribati': 'Kiribati',
    'Kuwait': 'Koweït',
    'Kyrgyzstan': 'Kirghizistan',
    'Laos': 'Laos',
    'Latvia': 'Lettonie',
    'Lebanon': 'Liban',
    'Lesotho': 'Lesotho',
    'Liberia': 'Libéria',
    'Libya': 'Libye',
    'Liechtenstein': 'Liechtenstein',
    'Lithuania': 'Lituanie',
    'Luxembourg': 'Luxembourg',
    'Madagascar': 'Madagascar',
    'Malawi': 'Malawi',
    'Malaysia': 'Malaisie',
    'Maldives': 'Maldives',
    'Mali': 'Mali',
    'Malta': 'Malte',
    'Marshall Islands': 'Îles Marshall',
    'Mauritania': 'Mauritanie',
    'Mauritius': 'Maurice',
    'Mexico': 'Mexique',
    'Micronesia': 'Micronésie',
    'Moldova': 'Moldavie',
    'Monaco': 'Monaco',
    'Mongolia': 'Mongolie',
    'Montenegro': 'Monténégro',
    'Morocco': 'Maroc',
    'Mozambique': 'Mozambique',
    'Myanmar': 'Myanmar',
    'Namibia': 'Namibie',
    'Nauru': 'Nauru',
    'Nepal': 'Népal',
    'Netherlands': 'Pays-Bas',
    'New Zealand': 'Nouvelle-Zélande',
    'Nicaragua': 'Nicaragua',
    'Niger': 'Niger',
    'Nigeria': 'Nigeria',
    'North Korea': 'Corée du Nord',
    'North Macedonia': 'Macédoine du Nord',
    'Norway': 'Norvège',
    'Oman': 'Oman',
    'Pakistan': 'Pakistan',
    'Palau': 'Palaos',
    'Palestine': 'Palestine',
    'Panama': 'Panama',
    'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
    'Paraguay': 'Paraguay',
    'Peru': 'Pérou',
    'Philippines': 'Philippines',
    'Poland': 'Pologne',
    'Portugal': 'Portugal',
    'Qatar': 'Qatar',
    'Romania': 'Roumanie',
    'Russia': 'Russie',
    'Rwanda': 'Rwanda',
    'Saint Kitts and Nevis': 'Saint-Kitts-et-Nevis',
    'Saint Lucia': 'Sainte-Lucie',
    'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
    'Samoa': 'Samoa',
    'San Marino': 'Saint-Marin',
    'Sao Tome and Principe': 'São Tomé-et-Principe',
    'Saudi Arabia': 'Arabie saoudite',
    'Senegal': 'Sénégal',
    'Serbia': 'Serbie',
    'Seychelles': 'Seychelles',
    'Sierra Leone': 'Sierra Leone',
    'Singapore': 'Singapour',
    'Slovakia': 'Slovaquie',
    'Slovenia': 'Slovénie',
    'Solomon Islands': 'Îles Salomon',
    'Somalia': 'Somalie',
    'South Africa': 'Afrique du Sud',
    'South Korea': 'Corée du Sud',
    'South Sudan': 'Soudan du Sud',
    'Spain': 'Espagne',
    'Sri Lanka': 'Sri Lanka',
    'Sudan': 'Soudan',
    'Suriname': 'Suriname',
    'Sweden': 'Suède',
    'Switzerland': 'Suisse',
    'Syria': 'Syrie',
    'Taiwan': 'Taïwan',
    'Tajikistan': 'Tadjikistan',
    'Tanzania': 'Tanzanie',
    'Thailand': 'Thaïlande',
    'Timor-Leste': 'Timor oriental',
    'Togo': 'Togo',
    'Tonga': 'Tonga',
    'Trinidad and Tobago': 'Trinité-et-Tobago',
    'Tunisia': 'Tunisie',
    'Turkey': 'Turquie',
    'Turkmenistan': 'Turkménistan',
    'Tuvalu': 'Tuvalu',
    'Uganda': 'Ouganda',
    'Ukraine': 'Ukraine',
    'United Arab Emirates': 'Émirats arabes unis',
    'United Kingdom': 'Royaume-Uni',
    'United States': 'États-Unis',
    'Uruguay': 'Uruguay',
    'Uzbekistan': 'Ouzbékistan',
    'Vanuatu': 'Vanuatu',
    'Vatican City': 'Vatican',
    'Venezuela': 'Venezuela',
    'Vietnam': 'Vietnam',
    'Yemen': 'Yémen',
    'Zambia': 'Zambie',
    'Zimbabwe': 'Zimbabwe'
};

export const currencyOptions = [
    { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
    { code: 'AFN', name: 'Afghan Afghani', symbol: '؋' },
    { code: 'ALL', name: 'Albanian Lek', symbol: 'L' },
    { code: 'AMD', name: 'Armenian Dram', symbol: '֏' },
    { code: 'ANG', name: 'Netherlands Antillean Guilder', symbol: 'ƒ' },
    { code: 'AOA', name: 'Angolan Kwanza', symbol: 'Kz' },
    { code: 'ARS', name: 'Argentine Peso', symbol: '$' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
    { code: 'AWG', name: 'Aruban Florin', symbol: 'ƒ' },
    { code: 'AZN', name: 'Azerbaijani Manat', symbol: '₼' },
    { code: 'BAM', name: 'Bosnia-Herzegovina Convertible Mark', symbol: 'KM' },
    { code: 'BBD', name: 'Barbadian Dollar', symbol: '$' },
    { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳' },
    { code: 'BGN', name: 'Bulgarian Lev', symbol: 'лв' },
    { code: 'BHD', name: 'Bahraini Dinar', symbol: '.د.ب' },
    { code: 'BIF', name: 'Burundian Franc', symbol: 'FBu' },
    { code: 'BMD', name: 'Bermudan Dollar', symbol: '$' },
    { code: 'BND', name: 'Brunei Dollar', symbol: '$' },
    { code: 'BOB', name: 'Bolivian Boliviano', symbol: '$b' },
    { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
    { code: 'BSD', name: 'Bahamian Dollar', symbol: '$' },
    { code: 'BTN', name: 'Bhutanese Ngultrum', symbol: 'Nu.' },
    { code: 'BWP', name: 'Botswanan Pula', symbol: 'P' },
    { code: 'BYN', name: 'Belarusian Ruble', symbol: 'Br' },
    { code: 'BZD', name: 'Belize Dollar', symbol: 'BZ$' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'CDF', name: 'Congolese Franc', symbol: 'FC' },
    { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
    { code: 'CLP', name: 'Chilean Peso', symbol: '$' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
    { code: 'COP', name: 'Colombian Peso', symbol: '$' },
    { code: 'CRC', name: 'Costa Rican Colón', symbol: '₡' },
    { code: 'CUP', name: 'Cuban Peso', symbol: '₱' },
    { code: 'CVE', name: 'Cape Verdean Escudo', symbol: '$' },
    { code: 'CZK', name: 'Czech Republic Koruna', symbol: 'Kč' },
    { code: 'DJF', name: 'Djiboutian Franc', symbol: 'Fdj' },
    { code: 'DKK', name: 'Danish Krone', symbol: 'kr' },
    { code: 'DOP', name: 'Dominican Peso', symbol: 'RD$' },
    { code: 'DZD', name: 'Algerian Dinar', symbol: 'دج' },
    { code: 'EGP', name: 'Egyptian Pound', symbol: '£' },
    { code: 'ERN', name: 'Eritrean Nakfa', symbol: 'Nfk' },
    { code: 'ETB', name: 'Ethiopian Birr', symbol: 'Br' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'FJD', name: 'Fijian Dollar', symbol: '$' },
    { code: 'FKP', name: 'Falkland Islands Pound', symbol: '£' },
    { code: 'GBP', name: 'British Pound Sterling', symbol: '£' },
    { code: 'GEL', name: 'Georgian Lari', symbol: '₾' },
    { code: 'GGP', name: 'Guernsey Pound', symbol: '£' },
    { code: 'GHS', name: 'Ghanaian Cedi', symbol: '¢' },
    { code: 'GIP', name: 'Gibraltar Pound', symbol: '£' },
    { code: 'GMD', name: 'Gambian Dalasi', symbol: 'D' },
    { code: 'GNF', name: 'Guinean Franc', symbol: 'FG' },
    { code: 'GTQ', name: 'Guatemalan Quetzal', symbol: 'Q' },
    { code: 'GYD', name: 'Guyanaese Dollar', symbol: '$' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
    { code: 'HNL', name: 'Honduran Lempira', symbol: 'L' },
    { code: 'HRK', name: 'Croatian Kuna', symbol: 'kn' },
    { code: 'HTG', name: 'Haitian Gourde', symbol: 'G' },
    { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft' },
    { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp' },
    { code: 'IMP', name: 'Manx pound', symbol: '£' },
    { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
    { code: 'IQD', name: 'Iraqi Dinar', symbol: 'ع.د' },
    { code: 'IRR', name: 'Iranian Rial', symbol: '﷼' },
    { code: 'ISK', name: 'Icelandic Króna', symbol: 'kr' },
    { code: 'JEP', name: 'Jersey Pound', symbol: '£' },
    { code: 'JMD', name: 'Jamaican Dollar', symbol: 'J$' },
    { code: 'JOD', name: 'Jordanian Dinar', symbol: 'JD' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'KES', name: 'Kenyan Shilling', symbol: 'KSh' },
    { code: 'KGS', name: 'Kyrgystani Som', symbol: 'лв' },
    { code: 'KHR', name: 'Cambodian Riel', symbol: '៛' },
    { code: 'KMF', name: 'Comorian Franc', symbol: 'CF' },
    { code: 'KPW', name: 'North Korean Won', symbol: '₩' },
    { code: 'KRW', name: 'South Korean Won', symbol: '₩' },
    { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'KD' },
    { code: 'KYD', name: 'Cayman Islands Dollar', symbol: '$' },
    { code: 'KZT', name: 'Kazakhstani Tenge', symbol: '₸' },
    { code: 'LAK', name: 'Laotian Kip', symbol: '₭' },
    { code: 'LBP', name: 'Lebanese Pound', symbol: '£' },
    { code: 'LKR', name: 'Sri Lankan Rupee', symbol: '₨' },
    { code: 'LRD', name: 'Liberian Dollar', symbol: '$' },
    { code: 'LSL', name: 'Lesotho Loti', symbol: 'M' },
    { code: 'LYD', name: 'Libyan Dinar', symbol: 'LD' },
    { code: 'MAD', name: 'Moroccan Dirham', symbol: 'MAD' },
    { code: 'MDL', name: 'Moldovan Leu', symbol: 'lei' },
    { code: 'MGA', name: 'Malagasy Ariary', symbol: 'Ar' },
    { code: 'MKD', name: 'Macedonian Denar', symbol: 'ден' },
    { code: 'MMK', name: 'Myanma Kyat', symbol: 'K' },
    { code: 'MNT', name: 'Mongolian Tugrik', symbol: '₮' },
    { code: 'MOP', name: 'Macanese Pataca', symbol: 'MOP$' },
    { code: 'MRU', name: 'Mauritanian Ouguiya', symbol: 'UM' },
    { code: 'MUR', name: 'Mauritian Rupee', symbol: '₨' },
    { code: 'MVR', name: 'Maldivian Rufiyaa', symbol: 'Rf' },
    { code: 'MWK', name: 'Malawian Kwacha', symbol: 'MK' },
    { code: 'MXN', name: 'Mexican Peso', symbol: '$' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
    { code: 'MZN', name: 'Mozambican Metical', symbol: 'MT' },
    { code: 'NAD', name: 'Namibian Dollar', symbol: '$' },
    { code: 'NGN', name: 'Nigerian Naira', symbol: '₦' },
    { code: 'NIO', name: 'Nicaraguan Córdoba', symbol: 'C$' },
    { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
    { code: 'NPR', name: 'Nepalese Rupee', symbol: '₨' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'OMR', name: 'Omani Rial', symbol: '﷼' },
    { code: 'PAB', name: 'Panamanian Balboa', symbol: 'B/.' },
    { code: 'PEN', name: 'Peruvian Nuevo Sol', symbol: 'S/.' },
    { code: 'PGK', name: 'Papua New Guinean Kina', symbol: 'K' },
    { code: 'PHP', name: 'Philippine Peso', symbol: '₱' },
    { code: 'PKR', name: 'Pakistani Rupee', symbol: '₨' },
    { code: 'PLN', name: 'Polish Zloty', symbol: 'zł' },
    { code: 'PYG', name: 'Paraguayan Guarani', symbol: 'Gs' },
    { code: 'QAR', name: 'Qatari Rial', symbol: '﷼' },
    { code: 'RON', name: 'Romanian Leu', symbol: 'lei' },
    { code: 'RSD', name: 'Serbian Dinar', symbol: 'Дин.' },
    { code: 'RUB', name: 'Russian Ruble', symbol: '₽' },
    { code: 'RWF', name: 'Rwandan Franc', symbol: 'R₣' },
    { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼' },
    { code: 'SBD', name: 'Solomon Islands Dollar', symbol: '$' },
    { code: 'SCR', name: 'Seychellois Rupee', symbol: '₨' },
    { code: 'SDG', name: 'Sudanese Pound', symbol: 'ج.س.' },
    { code: 'SEK', name: 'Swedish Krona', symbol: 'kr' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
    { code: 'SHP', name: 'Saint Helena Pound', symbol: '£' },
    { code: 'SLE', name: 'Sierra Leonean Leone', symbol: 'Le' },
    { code: 'SOS', name: 'Somali Shilling', symbol: 'S' },
    { code: 'SRD', name: 'Surinamese Dollar', symbol: '$' },
    { code: 'STN', name: 'São Tomé and Príncipe Dobra', symbol: 'Db' },
    { code: 'SVC', name: 'Salvadoran Colón', symbol: '$' },
    { code: 'SYP', name: 'Syrian Pound', symbol: '£' },
    { code: 'SZL', name: 'Swazi Lilangeni', symbol: 'E' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿' },
    { code: 'TJS', name: 'Tajikistani Somoni', symbol: 'SM' },
    { code: 'TMT', name: 'Turkmenistani Manat', symbol: 'T' },
    { code: 'TND', name: 'Tunisian Dinar', symbol: 'د.ت' },
    { code: 'TOP', name: 'Tongan Paʻanga', symbol: 'T$' },
    { code: 'TRY', name: 'Turkish Lira', symbol: '₺' },
    { code: 'TTD', name: 'Trinidad and Tobago Dollar', symbol: 'TT$' },
    { code: 'TWD', name: 'New Taiwan Dollar', symbol: 'NT$' },
    { code: 'TZS', name: 'Tanzanian Shilling', symbol: 'TSh' },
    { code: 'UAH', name: 'Ukrainian Hryvnia', symbol: '₴' },
    { code: 'UGX', name: 'Ugandan Shilling', symbol: 'USh' },
    { code: 'USD', name: 'United States Dollar', symbol: '$' },
    { code: 'UYU', name: 'Uruguayan Peso', symbol: '$U' },
    { code: 'UZS', name: 'Uzbekistan Som', symbol: 'лв' },
    { code: 'VED', name: 'Venezuelan Bolívar', symbol: 'Bs' },
    { code: 'VND', name: 'Vietnamese Dong', symbol: '₫' },
    { code: 'VUV', name: 'Vanuatu Vatu', symbol: 'VT' },
    { code: 'WST', name: 'Samoan Tala', symbol: 'WS$' },
    { code: 'XAF', name: 'CFA Franc BEAC', symbol: 'FCFA' },
    { code: 'XCD', name: 'East Caribbean Dollar', symbol: '$' },
    { code: 'XDR', name: 'Special Drawing Rights', symbol: 'SDR' },
    { code: 'XOF', name: 'CFA Franc BCEAO', symbol: 'CFA' },
    { code: 'XPF', name: 'CFP Franc', symbol: '₣' },
    { code: 'YER', name: 'Yemeni Rial', symbol: '﷼' },
    { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
    { code: 'ZMW', name: 'Zambian Kwacha', symbol: 'ZK' },
    { code: 'ZWL', name: 'Zimbabwean Dollar', symbol: 'Z$' }
];

export const languageOptions = [
    'Arabic', 'English', 'French', 'Other'
];

export const practiceCountryOptions = countryOptions;

export const phoneCountryCodes = [
    { code: '+93', country: 'Afghanistan', flagClass: 'fi fi-af', name: 'Afghanistan' },
    { code: '+355', country: 'Albania', flagClass: 'fi fi-al', name: 'Albania' },
    { code: '+213', country: 'Algeria', flagClass: 'fi fi-dz', name: 'Algeria' },
    { code: '+376', country: 'Andorra', flagClass: 'fi fi-ad', name: 'Andorra' },
    { code: '+244', country: 'Angola', flagClass: 'fi fi-ao', name: 'Angola' },
    { code: '+1268', country: 'Antigua and Barbuda', flagClass: 'fi fi-ag', name: 'Antigua and Barbuda' },
    { code: '+54', country: 'Argentina', flagClass: 'fi fi-ar', name: 'Argentina' },
    { code: '+374', country: 'Armenia', flagClass: 'fi fi-am', name: 'Armenia' },
    { code: '+61', country: 'Australia', flagClass: 'fi fi-au', name: 'Australia' },
    { code: '+43', country: 'Austria', flagClass: 'fi fi-at', name: 'Austria' },
    { code: '+994', country: 'Azerbaijan', flagClass: 'fi fi-az', name: 'Azerbaijan' },
    { code: '+1242', country: 'Bahamas', flagClass: 'fi fi-bs', name: 'Bahamas' },
    { code: '+973', country: 'Bahrain', flagClass: 'fi fi-bh', name: 'Bahrain' },
    { code: '+880', country: 'Bangladesh', flagClass: 'fi fi-bd', name: 'Bangladesh' },
    { code: '+1246', country: 'Barbados', flagClass: 'fi fi-bb', name: 'Barbados' },
    { code: '+375', country: 'Belarus', flagClass: 'fi fi-by', name: 'Belarus' },
    { code: '+32', country: 'Belgium', flagClass: 'fi fi-be', name: 'Belgium' },
    { code: '+501', country: 'Belize', flagClass: 'fi fi-bz', name: 'Belize' },
    { code: '+229', country: 'Benin', flagClass: 'fi fi-bj', name: 'Benin' },
    { code: '+975', country: 'Bhutan', flagClass: 'fi fi-bt', name: 'Bhutan' },
    { code: '+591', country: 'Bolivia', flagClass: 'fi fi-bo', name: 'Bolivia' },
    { code: '+387', country: 'Bosnia and Herzegovina', flagClass: 'fi fi-ba', name: 'Bosnia and Herzegovina' },
    { code: '+267', country: 'Botswana', flagClass: 'fi fi-bw', name: 'Botswana' },
    { code: '+55', country: 'Brazil', flagClass: 'fi fi-br', name: 'Brazil' },
    { code: '+673', country: 'Brunei', flagClass: 'fi fi-bn', name: 'Brunei' },
    { code: '+359', country: 'Bulgaria', flagClass: 'fi fi-bg', name: 'Bulgaria' },
    { code: '+226', country: 'Burkina Faso', flagClass: 'fi fi-bf', name: 'Burkina Faso' },
    { code: '+257', country: 'Burundi', flagClass: 'fi fi-bi', name: 'Burundi' },
    { code: '+238', country: 'Cabo Verde', flagClass: 'fi fi-cv', name: 'Cabo Verde' },
    { code: '+855', country: 'Cambodia', flagClass: 'fi fi-kh', name: 'Cambodia' },
    { code: '+237', country: 'Cameroon', flagClass: 'fi fi-cm', name: 'Cameroon' },
    { code: '+1', country: 'Canada', flagClass: 'fi fi-ca', name: 'Canada' },
    { code: '+236', country: 'Central African Republic', flagClass: 'fi fi-cf', name: 'Central African Republic' },
    { code: '+235', country: 'Chad', flagClass: 'fi fi-td', name: 'Chad' },
    { code: '+56', country: 'Chile', flagClass: 'fi fi-cl', name: 'Chile' },
    { code: '+86', country: 'China', flagClass: 'fi fi-cn', name: 'China' },
    { code: '+57', country: 'Colombia', flagClass: 'fi fi-co', name: 'Colombia' },
    { code: '+269', country: 'Comoros', flagClass: 'fi fi-km', name: 'Comoros' },
    { code: '+242', country: 'Congo', flagClass: 'fi fi-cg', name: 'Congo' },
    { code: '+506', country: 'Costa Rica', flagClass: 'fi fi-cr', name: 'Costa Rica' },
    { code: '+385', country: 'Croatia', flagClass: 'fi fi-hr', name: 'Croatia' },
    { code: '+53', country: 'Cuba', flagClass: 'fi fi-cu', name: 'Cuba' },
    { code: '+357', country: 'Cyprus', flagClass: 'fi fi-cy', name: 'Cyprus' },
    { code: '+420', country: 'Czech Republic', flagClass: 'fi fi-cz', name: 'Czech Republic' },
    { code: '+243', country: 'Democratic Republic of the Congo', flagClass: 'fi fi-cd', name: 'Democratic Republic of the Congo' },
    { code: '+45', country: 'Denmark', flagClass: 'fi fi-dk', name: 'Denmark' },
    { code: '+253', country: 'Djibouti', flagClass: 'fi fi-dj', name: 'Djibouti' },
    { code: '+1767', country: 'Dominica', flagClass: 'fi fi-dm', name: 'Dominica' },
    { code: '+1809', country: 'Dominican Republic', flagClass: 'fi fi-do', name: 'Dominican Republic' },
    { code: '+593', country: 'Ecuador', flagClass: 'fi fi-ec', name: 'Ecuador' },
    { code: '+20', country: 'Egypt', flagClass: 'fi fi-eg', name: 'Egypt' },
    { code: '+503', country: 'El Salvador', flagClass: 'fi fi-sv', name: 'El Salvador' },
    { code: '+240', country: 'Equatorial Guinea', flagClass: 'fi fi-gq', name: 'Equatorial Guinea' },
    { code: '+291', country: 'Eritrea', flagClass: 'fi fi-er', name: 'Eritrea' },
    { code: '+372', country: 'Estonia', flagClass: 'fi fi-ee', name: 'Estonia' },
    { code: '+268', country: 'Eswatini', flagClass: 'fi fi-sz', name: 'Eswatini' },
    { code: '+251', country: 'Ethiopia', flagClass: 'fi fi-et', name: 'Ethiopia' },
    { code: '+679', country: 'Fiji', flagClass: 'fi fi-fj', name: 'Fiji' },
    { code: '+358', country: 'Finland', flagClass: 'fi fi-fi', name: 'Finland' },
    { code: '+33', country: 'France', flagClass: 'fi fi-fr', name: 'France' },
    { code: '+241', country: 'Gabon', flagClass: 'fi fi-ga', name: 'Gabon' },
    { code: '+220', country: 'Gambia', flagClass: 'fi fi-gm', name: 'Gambia' },
    { code: '+995', country: 'Georgia', flagClass: 'fi fi-ge', name: 'Georgia' },
    { code: '+49', country: 'Germany', flagClass: 'fi fi-de', name: 'Germany' },
    { code: '+233', country: 'Ghana', flagClass: 'fi fi-gh', name: 'Ghana' },
    { code: '+30', country: 'Greece', flagClass: 'fi fi-gr', name: 'Greece' },
    { code: '+1473', country: 'Grenada', flagClass: 'fi fi-gd', name: 'Grenada' },
    { code: '+502', country: 'Guatemala', flagClass: 'fi fi-gt', name: 'Guatemala' },
    { code: '+224', country: 'Guinea', flagClass: 'fi fi-gn', name: 'Guinea' },
    { code: '+245', country: 'Guinea-Bissau', flagClass: 'fi fi-gw', name: 'Guinea-Bissau' },
    { code: '+592', country: 'Guyana', flagClass: 'fi fi-gy', name: 'Guyana' },
    { code: '+509', country: 'Haiti', flagClass: 'fi fi-ht', name: 'Haiti' },
    { code: '+504', country: 'Honduras', flagClass: 'fi fi-hn', name: 'Honduras' },
    { code: '+36', country: 'Hungary', flagClass: 'fi fi-hu', name: 'Hungary' },
    { code: '+354', country: 'Iceland', flagClass: 'fi fi-is', name: 'Iceland' },
    { code: '+91', country: 'India', flagClass: 'fi fi-in', name: 'India' },
    { code: '+62', country: 'Indonesia', flagClass: 'fi fi-id', name: 'Indonesia' },
    { code: '+98', country: 'Iran', flagClass: 'fi fi-ir', name: 'Iran' },
    { code: '+964', country: 'Iraq', flagClass: 'fi fi-iq', name: 'Iraq' },
    { code: '+353', country: 'Ireland', flagClass: 'fi fi-ie', name: 'Ireland' },
    { code: '+39', country: 'Italy', flagClass: 'fi fi-it', name: 'Italy' },
    { code: '+225', country: 'Ivory Coast', flagClass: 'fi fi-ci', name: 'Ivory Coast' },
    { code: '+1876', country: 'Jamaica', flagClass: 'fi fi-jm', name: 'Jamaica' },
    { code: '+81', country: 'Japan', flagClass: 'fi fi-jp', name: 'Japan' },
    { code: '+962', country: 'Jordan', flagClass: 'fi fi-jo', name: 'Jordan' },
    { code: '+7', country: 'Kazakhstan', flagClass: 'fi fi-kz', name: 'Kazakhstan' },
    { code: '+254', country: 'Kenya', flagClass: 'fi fi-ke', name: 'Kenya' },
    { code: '+686', country: 'Kiribati', flagClass: 'fi fi-ki', name: 'Kiribati' },
    { code: '+965', country: 'Kuwait', flagClass: 'fi fi-kw', name: 'Kuwait' },
    { code: '+996', country: 'Kyrgyzstan', flagClass: 'fi fi-kg', name: 'Kyrgyzstan' },
    { code: '+856', country: 'Laos', flagClass: 'fi fi-la', name: 'Laos' },
    { code: '+371', country: 'Latvia', flagClass: 'fi fi-lv', name: 'Latvia' },
    { code: '+961', country: 'Lebanon', flagClass: 'fi fi-lb', name: 'Lebanon' },
    { code: '+266', country: 'Lesotho', flagClass: 'fi fi-ls', name: 'Lesotho' },
    { code: '+231', country: 'Liberia', flagClass: 'fi fi-lr', name: 'Liberia' },
    { code: '+218', country: 'Libya', flagClass: 'fi fi-ly', name: 'Libya' },
    { code: '+423', country: 'Liechtenstein', flagClass: 'fi fi-li', name: 'Liechtenstein' },
    { code: '+370', country: 'Lithuania', flagClass: 'fi fi-lt', name: 'Lithuania' },
    { code: '+352', country: 'Luxembourg', flagClass: 'fi fi-lu', name: 'Luxembourg' },
    { code: '+261', country: 'Madagascar', flagClass: 'fi fi-mg', name: 'Madagascar' },
    { code: '+265', country: 'Malawi', flagClass: 'fi fi-mw', name: 'Malawi' },
    { code: '+60', country: 'Malaysia', flagClass: 'fi fi-my', name: 'Malaysia' },
    { code: '+960', country: 'Maldives', flagClass: 'fi fi-mv', name: 'Maldives' },
    { code: '+223', country: 'Mali', flagClass: 'fi fi-ml', name: 'Mali' },
    { code: '+356', country: 'Malta', flagClass: 'fi fi-mt', name: 'Malta' },
    { code: '+692', country: 'Marshall Islands', flagClass: 'fi fi-mh', name: 'Marshall Islands' },
    { code: '+222', country: 'Mauritania', flagClass: 'fi fi-mr', name: 'Mauritania' },
    { code: '+230', country: 'Mauritius', flagClass: 'fi fi-mu', name: 'Mauritius' },
    { code: '+52', country: 'Mexico', flagClass: 'fi fi-mx', name: 'Mexico' },
    { code: '+691', country: 'Micronesia', flagClass: 'fi fi-fm', name: 'Micronesia' },
    { code: '+373', country: 'Moldova', flagClass: 'fi fi-md', name: 'Moldova' },
    { code: '+377', country: 'Monaco', flagClass: 'fi fi-mc', name: 'Monaco' },
    { code: '+976', country: 'Mongolia', flagClass: 'fi fi-mn', name: 'Mongolia' },
    { code: '+382', country: 'Montenegro', flagClass: 'fi fi-me', name: 'Montenegro' },
    { code: '+212', country: 'Morocco', flagClass: 'fi fi-ma', name: 'Morocco' },
    { code: '+258', country: 'Mozambique', flagClass: 'fi fi-mz', name: 'Mozambique' },
    { code: '+95', country: 'Myanmar', flagClass: 'fi fi-mm', name: 'Myanmar' },
    { code: '+264', country: 'Namibia', flagClass: 'fi fi-na', name: 'Namibia' },
    { code: '+674', country: 'Nauru', flagClass: 'fi fi-nr', name: 'Nauru' },
    { code: '+977', country: 'Nepal', flagClass: 'fi fi-np', name: 'Nepal' },
    { code: '+31', country: 'Netherlands', flagClass: 'fi fi-nl', name: 'Netherlands' },
    { code: '+64', country: 'New Zealand', flagClass: 'fi fi-nz', name: 'New Zealand' },
    { code: '+505', country: 'Nicaragua', flagClass: 'fi fi-ni', name: 'Nicaragua' },
    { code: '+227', country: 'Niger', flagClass: 'fi fi-ne', name: 'Niger' },
    { code: '+234', country: 'Nigeria', flagClass: 'fi fi-ng', name: 'Nigeria' },
    { code: '+850', country: 'North Korea', flagClass: 'fi fi-kp', name: 'North Korea' },
    { code: '+389', country: 'North Macedonia', flagClass: 'fi fi-mk', name: 'North Macedonia' },
    { code: '+47', country: 'Norway', flagClass: 'fi fi-no', name: 'Norway' },
    { code: '+968', country: 'Oman', flagClass: 'fi fi-om', name: 'Oman' },
    { code: '+92', country: 'Pakistan', flagClass: 'fi fi-pk', name: 'Pakistan' },
    { code: '+680', country: 'Palau', flagClass: 'fi fi-pw', name: 'Palau' },
    { code: '+970', country: 'Palestine', flagClass: 'fi fi-ps', name: 'Palestine' },
    { code: '+507', country: 'Panama', flagClass: 'fi fi-pa', name: 'Panama' },
    { code: '+675', country: 'Papua New Guinea', flagClass: 'fi fi-pg', name: 'Papua New Guinea' },
    { code: '+595', country: 'Paraguay', flagClass: 'fi fi-py', name: 'Paraguay' },
    { code: '+51', country: 'Peru', flagClass: 'fi fi-pe', name: 'Peru' },
    { code: '+63', country: 'Philippines', flagClass: 'fi fi-ph', name: 'Philippines' },
    { code: '+48', country: 'Poland', flagClass: 'fi fi-pl', name: 'Poland' },
    { code: '+351', country: 'Portugal', flagClass: 'fi fi-pt', name: 'Portugal' },
    { code: '+974', country: 'Qatar', flagClass: 'fi fi-qa', name: 'Qatar' },
    { code: '+40', country: 'Romania', flagClass: 'fi fi-ro', name: 'Romania' },
    { code: '+7', country: 'Russia', flagClass: 'fi fi-ru', name: 'Russia' },
    { code: '+250', country: 'Rwanda', flagClass: 'fi fi-rw', name: 'Rwanda' },
    { code: '+1869', country: 'Saint Kitts and Nevis', flagClass: 'fi fi-kn', name: 'Saint Kitts and Nevis' },
    { code: '+1758', country: 'Saint Lucia', flagClass: 'fi fi-lc', name: 'Saint Lucia' },
    { code: '+1784', country: 'Saint Vincent and the Grenadines', flagClass: 'fi fi-vc', name: 'Saint Vincent and the Grenadines' },
    { code: '+685', country: 'Samoa', flagClass: 'fi fi-ws', name: 'Samoa' },
    { code: '+378', country: 'San Marino', flagClass: 'fi fi-sm', name: 'San Marino' },
    { code: '+239', country: 'Sao Tome and Principe', flagClass: 'fi fi-st', name: 'Sao Tome and Principe' },
    { code: '+966', country: 'Saudi Arabia', flagClass: 'fi fi-sa', name: 'Saudi Arabia' },
    { code: '+221', country: 'Senegal', flagClass: 'fi fi-sn', name: 'Senegal' },
    { code: '+381', country: 'Serbia', flagClass: 'fi fi-rs', name: 'Serbia' },
    { code: '+248', country: 'Seychelles', flagClass: 'fi fi-sc', name: 'Seychelles' },
    { code: '+232', country: 'Sierra Leone', flagClass: 'fi fi-sl', name: 'Sierra Leone' },
    { code: '+65', country: 'Singapore', flagClass: 'fi fi-sg', name: 'Singapore' },
    { code: '+421', country: 'Slovakia', flagClass: 'fi fi-sk', name: 'Slovakia' },
    { code: '+386', country: 'Slovenia', flagClass: 'fi fi-si', name: 'Slovenia' },
    { code: '+677', country: 'Solomon Islands', flagClass: 'fi fi-sb', name: 'Solomon Islands' },
    { code: '+252', country: 'Somalia', flagClass: 'fi fi-so', name: 'Somalia' },
    { code: '+27', country: 'South Africa', flagClass: 'fi fi-za', name: 'South Africa' },
    { code: '+82', country: 'South Korea', flagClass: 'fi fi-kr', name: 'South Korea' },
    { code: '+211', country: 'South Sudan', flagClass: 'fi fi-ss', name: 'South Sudan' },
    { code: '+34', country: 'Spain', flagClass: 'fi fi-es', name: 'Spain' },
    { code: '+94', country: 'Sri Lanka', flagClass: 'fi fi-lk', name: 'Sri Lanka' },
    { code: '+249', country: 'Sudan', flagClass: 'fi fi-sd', name: 'Sudan' },
    { code: '+597', country: 'Suriname', flagClass: 'fi fi-sr', name: 'Suriname' },
    { code: '+46', country: 'Sweden', flagClass: 'fi fi-se', name: 'Sweden' },
    { code: '+41', country: 'Switzerland', flagClass: 'fi fi-ch', name: 'Switzerland' },
    { code: '+963', country: 'Syria', flagClass: 'fi fi-sy', name: 'Syria' },
    { code: '+886', country: 'Taiwan', flagClass: 'fi fi-tw', name: 'Taiwan' },
    { code: '+992', country: 'Tajikistan', flagClass: 'fi fi-tj', name: 'Tajikistan' },
    { code: '+255', country: 'Tanzania', flagClass: 'fi fi-tz', name: 'Tanzania' },
    { code: '+66', country: 'Thailand', flagClass: 'fi fi-th', name: 'Thailand' },
    { code: '+670', country: 'Timor-Leste', flagClass: 'fi fi-tl', name: 'Timor-Leste' },
    { code: '+228', country: 'Togo', flagClass: 'fi fi-tg', name: 'Togo' },
    { code: '+676', country: 'Tonga', flagClass: 'fi fi-to', name: 'Tonga' },
    { code: '+1868', country: 'Trinidad and Tobago', flagClass: 'fi fi-tt', name: 'Trinidad and Tobago' },
    { code: '+216', country: 'Tunisia', flagClass: 'fi fi-tn', name: 'Tunisia' },
    { code: '+90', country: 'Turkey', flagClass: 'fi fi-tr', name: 'Turkey' },
    { code: '+993', country: 'Turkmenistan', flagClass: 'fi fi-tm', name: 'Turkmenistan' },
    { code: '+688', country: 'Tuvalu', flagClass: 'fi fi-tv', name: 'Tuvalu' },
    { code: '+256', country: 'Uganda', flagClass: 'fi fi-ug', name: 'Uganda' },
    { code: '+380', country: 'Ukraine', flagClass: 'fi fi-ua', name: 'Ukraine' },
    { code: '+971', country: 'United Arab Emirates', flagClass: 'fi fi-ae', name: 'United Arab Emirates' },
    { code: '+44', country: 'United Kingdom', flagClass: 'fi fi-gb', name: 'United Kingdom' },
    { code: '+1', country: 'United States', flagClass: 'fi fi-us', name: 'United States' },
    { code: '+598', country: 'Uruguay', flagClass: 'fi fi-uy', name: 'Uruguay' },
    { code: '+998', country: 'Uzbekistan', flagClass: 'fi fi-uz', name: 'Uzbekistan' },
    { code: '+678', country: 'Vanuatu', flagClass: 'fi fi-vu', name: 'Vanuatu' },
    { code: '+379', country: 'Vatican City', flagClass: 'fi fi-va', name: 'Vatican City' },
    { code: '+58', country: 'Venezuela', flagClass: 'fi fi-ve', name: 'Venezuela' },
    { code: '+84', country: 'Vietnam', flagClass: 'fi fi-vn', name: 'Vietnam' },
    { code: '+967', country: 'Yemen', flagClass: 'fi fi-ye', name: 'Yemen' },
    { code: '+260', country: 'Zambia', flagClass: 'fi fi-zm', name: 'Zambia' },
    { code: '+263', country: 'Zimbabwe', flagClass: 'fi fi-zw', name: 'Zimbabwe' }
];
